/**
 * Thin <img> wrapper around the canonical SVG at
 * frontend/public/vynaemr.svg. Keep all visual changes to that
 * file — this component only centralizes the alt text, accessibility
 * attributes, and a default className so callers can `<Logo />`
 * without repeating themselves.
 *
 * Why an <img>: the SVG has hard-coded fills (gradient + white) so
 * it doesn't need `currentColor` or CSS-driven styling. A plain
 * <img> is simpler than vite-plugin-svgr for this case and avoids
 * duplicating the SVG source between the public asset and an
 * inline React copy.
 */
import { useTranslation } from 'react-i18next'

export default function Logo({ className = '' }: { className?: string }) {
  const { t } = useTranslation('common')
  return (
    <img
      src="/vynaemr.svg"
      alt={t('appName')}
      className={className}
      draggable={false}
    />
  )
}
